import { role } from "shared/src/roles.mjs";
import { groupBy } from "shared/src/util.mjs";
import {
  appointmentStatusPriority,
  interestingAppointmentStatus,
} from "shared/src/resource.mjs";

/**
 * @param {number} ms
 *
 * @returns {number}
 */
export function msToM(ms) {
  return Math.trunc(ms / 1000 / 60);
}

/**
 * @param {Date} start
 * @param {Date} end
 */
export function duration(start, end) {
  return msToM(end - start);
}

export function serviceFormat(serviceType) {
  return `app.service.${serviceType}/json`;
}

export function serviceFormatList(service, groupId) {
  const actual_calendar = service?.locationService?.actual_calendar ?? {};

  return [
    ...(actual_calendar.types ?? []).map((t) => serviceFormat(t)),
    ...(actual_calendar.ids ?? []).map((id) => serviceFormat(id)),
    ...(groupId != null ? [serviceFormat(groupId)] : []),
  ];
}

const interestingResourceStatus = new Set(interestingAppointmentStatus);

export const employeeStatusToLabel = {
  available: "Volný personál",
  assigned: "Přiřazený personál",
  unavailable: "Nepřítomný personál",
};

function compareNumbers(n1, n2) {
  return n2 - n1;
}

export function getAppointmentsByCalendarId(appointments) {
  const appointmentsByCalendarId = groupBy(
    appointments.filter((a) => interestingResourceStatus.has(a.status_id)),
    (a) => a.actual_calendar_id,
  );
  Object.values(appointmentsByCalendarId).forEach((appointments) => {
    appointments.sort((a1, a2) =>
      compareNumbers(
        appointmentStatusPriority[a1.status_id],
        appointmentStatusPriority[a2.status_id],
      ),
    );
  });

  return appointmentsByCalendarId;
}

export function getAssignableRoles(appointments) {
  if (appointments[0]?.service?.type === "consultation") {
    return [role.Treatment_Coordinator];
  }

  return [role.Dental_Assistant, role.Floor_Manager];
}
